import Socket, { Message } from '../connection/socket';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { GreenroomState as GS } from '../stores/types/types';
import * as Actions from '../stores/actions/generate-content';

function socketLoadGeneratedContentById({ message }: Message) {
	const {
		SessionReducer: {
			token,
			meeting,
		},
	} = getState() as GS;

	if (token && meeting) {
		socketListenerDispatch(Actions.loadGeneratedContentById(token, meeting, message.id));
	}
}

function socketLoadGeneratedContent() {
	const {
		SessionReducer: {
			token,
			meeting,
		},
	} = getState() as GS;

	if (token && meeting) {
		socketListenerDispatch(Actions.loadGeneratedContent(token, meeting));
	}
}

export default function GenerateContent(socket: Socket) {
	socket.addListener('load-generated-content-by-id', socketLoadGeneratedContentById);
	socket.addListener('load-generated-content', socketLoadGeneratedContent);
}
